/**
 * @flow
 * Created by neo on 05.03.17.
 */
import mobx, {observable, action, computed} from 'mobx';
import Flight from '../Flight';
import Passenger from './Passenger';
import BackendFactory from '../../Services/BackendFactory';
import Payment from '../Payment';
import Address from '../Address';
import Voucher from '../Voucher';
import moment from 'moment-timezone';
import FlightOffer from '../FlightOffer';
import AbstractBookingRequest from './AbstractBookingRequest';

export default class FlightBookingRequest extends AbstractBookingRequest {
  @observable flight: Flight = new Flight();

  constructor(json?: any) {
    super(json);

    if(json) {
      this.flight = new Flight(json.flight);
      this.payment_types = (json.payment_types || this.flight.aircraft_offer.flight_offer.payment_types).map(p => new Payment(p));
      this.payment = new Payment(json.payment || this.payment_types[0]);
    }
  }

  @action async send(): Promise<?string> {
    const backend = await BackendFactory();

    const res = await backend.post('/flight/' + this.flight.id + '/book', {
      start_time: this.flight.start_time,
      booking: {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        phone: this.phone,
        note: this.note,
        check_insurance_info: this.check_insurance_info,
        check_safety_info: this.check_safety_info,
        carry_on_count: this.carry_on_count || 0,
        suitcase_count: this.suitcase_count || 0,
        price: this.actualPrice
      },
      passengers: mobx.toJS(this.passengers),
      payment: {
        token: this.payment.token,
        id: this.payment.id,
        name: this.payment.name,
        total_price: this.actualPrice + this.paymentMethodCommission
      },
      address: mobx.toJS(this.address),
      voucher: mobx.toJS(this.voucher),
      promo_code: mobx.toJS(this.promo_code)
    });

    if(res.ok) {
      return res.data;
    }

    if (res.data && res.data.error) {
      return {
        error: res.data.error
      };
    }

    return null;
  }

  @computed get flightOffer(): FlightOffer {
    return this.flight.aircraft_offer.flight_offer;
  }

  @computed get aircraft(): FlightOffer {
    return this.flight.aircraft_offer;
  }

  @computed get maxPassengers(): number {
    return this.flight.available_seats;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Booking/FlightBookingRequest.js